import { Component, OnInit } from '@angular/core';
import { Field } from '../../models/field.interface';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FieldConfig } from '../../models/field-config.interface';
import { Masks } from '@core/custom-validators/masks';
import { CustomValidators } from '@core/custom-validators/validators';

@Component({
  selector: 'app-form-cpf-cnpj',
  templateUrl: './form-cpf-cnpj.component.html',
  styleUrls: ['./form-cpf-cnpj.component.scss']
})
export class FormCpfCnpjComponent implements Field, OnInit {
  formCPFCNPJ: FormGroup;
  config: FieldConfig;
  group: FormGroup;
  mask = {
    mask: Masks.cpfCnpj,
    guide: false,
    modelClean: true
  };
  firstSubmit = false;

  constructor(private formBuilder: FormBuilder) {

  }

  ngOnInit(): void {
    this.formCPFCNPJ = this.formBuilder.group({
      cpfCnpj: ['']
    })

    if (this.config.required) {
      this.cpfCnpj.setValidators(Validators.compose([Validators.required, CustomValidators.cpfCnpj]))
    }
    else
      this.cpfCnpj.setValidators(Validators.compose([CustomValidators.cpfCnpj]))

    this.group.statusChanges.subscribe((val) => {
      if (!this.firstSubmit) {
        this.firstSubmit = true;
        this.cpfCnpj.setValue(this.cpfCnpj.value);
      }
    })

    this.cpfCnpj.valueChanges.subscribe((val) => {
      if (this.cpfCnpj.valid) {
        this.control.setValue(this.clearMaskValue(val));
      }
      else {
        this.control.setValue(undefined);
      }
    })
  }

  get cpfCnpj() {
    return this.formCPFCNPJ.controls.cpfCnpj;
  }

  get control() {
    return this.group.controls[this.config.name];
  }

  clearMaskValue(val): string {
    if (val)
      return val.replace(/[^\w\s]/gi, '');

    return val;
  }
}